module.exports = __webpack_public_path__ + "static/media/sup_tropical_tiny.67bb81fd.webp";